import { loginURL, logoutURL } from '$src/constants/urls';
import getEnvironment from './enviroment';

export function getLoginURL() {
  return `${loginURL[getEnvironment()]}?return=vsg-control-center&path=${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function getLogoutURL() {
  return logoutURL[getEnvironment()];
}
